var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChangePwd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.66 9.95948L10.59 17.065L6.35 12.8037L7.76 11.3866L10.59 14.2308L16.25 8.5424L17.66 9.95948ZM4 12.4419C4 10.1002 5.02 7.99968 6.62 6.53235L9 8.92431V2.89416H3L5.2 5.10521C3.24 6.93436 2 9.53737 2 12.4419C2 17.658 5.95 21.9394 11 22.4419V20.4117C7.06 19.9193 4 16.5323 4 12.4419ZM22 12.4419C22 7.22581 18.05 2.94441 13 2.44189V4.47205C16.94 4.96451 20 8.35144 20 12.4419C20 14.7836 18.98 16.8841 17.38 18.3514L15 15.9595V21.9896H21L18.8 19.7786C20.76 17.9494 22 15.3464 22 12.4419Z",
    fill: "#44494D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChangePwd);
export default __webpack_public_path__ + "static/media/IconChangePwd.71f9727f.svg";
export { ForwardRef as ReactComponent };